/**
 * ShareChat Analytics Utility
 * Provides functions to track events with ShareChat's analytics SDK
 */

// Check if scq is available before calling
const isShareChatAvailable = () => {
  return typeof window !== 'undefined' && typeof window.scq === 'function';
};

/**
 * Safely execute function when SDK is ready
 * @param {Function} callback - Function to execute
 */
const whenReady = (callback) => {
  if (isShareChatAvailable()) {
    callback();
  } else {
    console.log("ShareChat SDK not ready, waiting...");
    // Try again after a short delay
    const wait = setTimeout(() => {
      clearTimeout(wait);
      whenReady(callback);
    }, 500);
  }
};

/**
 * Track an event with ShareChat analytics
 * @param {string} eventName - Name of the event to track
 * @param {object} eventProps - Optional properties to include with the event
 */
const trackEvent = (eventName, eventProps = {}) => {
  whenReady(() => {
    try {
      window.scq(eventName, 'pre_defined', eventProps);
      console.log(`ShareChat Analytics: ${eventName} event tracked`, eventProps);
    } catch (error) {
      console.error(`ShareChat Analytics: Failed to track ${eventName} event`, error);
    }
  });
};

/**
 * Track AddToCart event
 * @param {object} product - Product data
 */
const trackAddToCart = (product) => {
  const eventProps = {
    product_id: product.subscription_plan_id || product.id,
    product_name: product.plan_name || product.name,
    price: product.discounted_cost || product.price || 0,
    currency: product.currency_type || 'INR',
    quantity: 1
  };
  
  trackEvent('Add to cart', eventProps);
};

const trackAddToCart2 = (planData) => {
  const eventProps = {
    product_id: planData.subscription_plan_id || planData.id,
    product_name: planData.plan_name || planData.name,
    price: planData.discounted_cost || planData.price || 0,
  };

  trackEvent('Add to cart', eventProps);
};

/**
 * Track Purchase event
 * @param {object} orderData - Order data
 */
const trackPurchase = (orderData) => {
  // Calculate total quantity
  const quantity = orderData.items ? 
    orderData.items.reduce((total, item) => total + (item.quantity || 1), 0) : 1;
  
  const eventProps = {
    transaction_id: orderData.order_id || orderData.id,
    value: orderData.payment?.amount || orderData.total_amount || orderData.amount || 0,
    currency: orderData.currency_type || 'INR',
    items: orderData.items || [],
    quantity: quantity,
    payment_method: orderData.payment?.payment_method || orderData.payment_method
  };
  
  trackEvent('Purchase', eventProps);
};

export default {
  trackEvent,
  trackAddToCart,
  trackPurchase,
  trackAddToCart2,
  whenReady
}; 